module.exports = __webpack_public_path__ + "img/centerIndexImg.56941332.png";